const KEY = "clikkle.accounts.pendingAuthentication";

export function savePendingAuthentication(payload) {
  sessionStorage.setItem(KEY, JSON.stringify({ ...payload, storedAt: Date.now() }));
}

export function getPendingAuthentication() {
  try {
    const payload = JSON.parse(sessionStorage.getItem(KEY) || "null");
    if (!payload?.security?.challengeToken) return null;
    const ttl = Number(payload.security.expiresInSeconds || 300) * 1000;
    if (Date.now() - Number(payload.storedAt || 0) > ttl) {
      sessionStorage.removeItem(KEY);
      return null;
    }
    return payload;
  } catch {
    return null;
  }
}

export function clearPendingAuthentication() {
  sessionStorage.removeItem(KEY);
}
